import React, { useEffect, useState } from "react";
import './styles.css'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import { useLocation, useNavigate } from 'react-router-dom';
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux'
import { messageListRequest, chatSendMessageRequest, chatSendMessageRequestStatus } from '../../../redux/chat/chat.action'
import moment from "moment";
import { isNull, displaySuccessToast, displayErrorToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee } from "../../../utils/Utils";
import { API_CONSTANTS, APP_CONSTANTS } from "../../../utils/AppConstants";
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";
import CommonFormBorder from "../../../components/common-form-border/commonFormBorder";

const MessageList = props => {
    const { state } = useLocation()
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const { user, employeeSelectedBusiness } = useSelector((state) => state.user)
    const { messageListSuccess, messageListError, chatSendMessageSuccess, chatSendMessageError, chatSendMessageReqStatus } = useSelector((state) => state.chat)
    const [message, setMessage] = useState('')

    useEffect(() => {
        fetchMessageList()
    }, [])

    const fetchMessageList = () => {
        setLoading(true)
        const data = {
            id: state.chat.chatId,
            params: {
                businessId: state.businessId
            }
        }
        dispatch(messageListRequest(data))
    }

    useEffect(() => {
        if (!isNull(messageListSuccess)) {
            setLoading(false)
        } else if (!isNull(messageListError)) {
            setLoading(false)
        }
    }, [messageListSuccess, messageListError])

    useEffect(() => {
        if (chatSendMessageReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(chatSendMessageSuccess.message)
            setMessage('')
            fetchMessageList()
        } else if (chatSendMessageReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(chatSendMessageError.message)
        }
        if (chatSendMessageReqStatus.length) {
            dispatch(chatSendMessageRequestStatus(''))
        }
    }, [chatSendMessageSuccess, chatSendMessageError, chatSendMessageReqStatus])

    const isLoggedInUserSender = (item) => {
        if (isLoggedInUserBusiness(user) && item.senderId === user.data.userDetails.userId && item.userType === user.data.userDetails.userType) {
            return true
        } else if (isLoggedInUserEmployee(user) && item.senderId === user.data.userDetails.employeeId && item.userType === user.data.userDetails.userType) {
            return true
        } else {
            return false
        }
    }

    const handleSendMessage = () => {
        if (isEmpty(message)) {
            displayErrorToast('Message cannot be blank')
        } else {
            const data = {
                message: message,
                senderId: user.data.userDetails.userType === APP_CONSTANTS.USER_ROLE_TYPE.BUSINESS ? user.data.userDetails.userId : user.data.userDetails.employeeId,
                userType: user.data.userDetails.userType,
                productCode: state.chat.productCode,
                receivers: state.chat.users,
                chatType: state.chat.chatType,
                groupName: state.chat.groupName,
                businessId: state.businessId,
                chatId: state.chat.chatId
            }
            setLoading(true)
            dispatch(chatSendMessageRequest(data))
        }
    }

    return (
        <>
            <div className="ml-parent-content-container">
                <ScreenLabel label='Message List' />
                {!isNull(messageListSuccess) && !isEmpty(messageListSuccess.data) &&
                    <div className="parent-continer">
                        <div className="list-container">
                            {/* <CommonFormBorder> */}
                            {messageListSuccess.data.map(e => (
                                <div className="rtd-message-container">
                                    <div className="rtd-select-heading-date">{moment.utc(e.createdOn).local().format('DD/MM/YYYY HH:mm A')}</div>
                                    <div className="rtd-content-text">{e.message}</div>
                                    {isLoggedInUserSender(e) ? (
                                        <div className="rtd-select-heading-left">You</div>
                                    ) : (<div className="rtd-select-heading">{!isEmpty(e.senderDetails) ? `${e.senderDetails.firstName} ${e.senderDetails.lastName}` : 'Anonymous'}</div>)}

                                </div>
                            ))}
                            {/* </CommonFormBorder> */}
                        </div>
                        <div className="fixed-container">
                            <CommonInputFloatFull
                                id='message'
                                onChange={e => setMessage(e.target.value)}
                                placeholder='Message'
                                type='text'
                                value={message}
                                isRequired={true}
                            />
                            <div className="send-icon-container" onClick={() => { handleSendMessage() }}>
                                <img src={require('../../../assets/ic_send_message.png')} className="img" />
                            </div>
                        </div>
                    </div>}
                {!isNull(messageListError) && <div className="content-error">{messageListError.message}</div>}
            </div>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default MessageList